const RESPONSE = {
  shipmentId: true,
  displayName: true,
  documentType: false,
  documentExtension: false,
  documentNumber: false,
  fileName: false,
  createdDateTime: false,
  atType: false,
  atBaseType: false,
  message: true
};

export class UploadDocumentModel {
  uploadDocument(payload: any) {
    return {
      mutation: {
        submitDocument: {
          __args: {
            input: payload
          },
          ...RESPONSE
        }
      }
    };
  }
  uploadInvoice(payload: any) {
    return {
      mutation: {
        uploadInvoice: {
          __args: {
            input: payload
          },
          ...RESPONSE
        }
      }
    };
  }
  createInvoice(payload: any) {
    return {
      mutation: {
        createInvoice: {
          __args: {
            input: payload
          },
          response: true,
          message: true,
          status: true
        }
      }
    };
  }
}
